// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1ahb8","col":"Table_col__1q22N","fulfillmentStatus":"Table_fulfillmentStatus__2PuHV","emailCol":"Table_emailCol__DTfct"};